<template>
  <li class="header-user-block__list-item" :class="{ open: isActive }">
    <span class="header-user-block__list-label" :class="{ disabled: items.length <= 1 }" :disabled="items.length <= 1" @click="toggleDropdown">
        <span class="header-user-block__list-name" v-if="isLanguage">
            <img class="flag" :src="`/img/flags/lang-header/${code}.svg?v=3`" :alt="code">
            <span class="header-user-block__list-item-text">
                {{ code }}
            </span>
        </span>
        <span class="header-user-block__list-currency" :class="`currency-item_${code}`" v-else>
            <span class="header-user-block__list-currency-symbol header-user-block__label-bullet">
                {{ current }}
            </span>
            <span class="header-user-block__list-item-text">
                {{ code }}
            </span>
        </span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99996 10.4541C7.83269 10.4541 7.66544 10.3902 7.53791 10.2627L3.52478 6.24955C3.26949 5.99427 3.26949 5.58036 3.52478 5.32518C3.77996 5.06999 4.19379 5.06999 4.44909 5.32518L7.99996 8.87626L11.5509 5.3253C11.8061 5.07012 12.2199 5.07012 12.4751 5.3253C12.7305 5.58049 12.7305 5.99439 12.4751 6.24968L8.46202 10.2629C8.33443 10.3903 8.16718 10.4541 7.99996 10.4541Z" fill="#C9C9C9"/>
        </svg>
    </span>
    <div class="header-user-block__list-dropdown">
      <SlideUpDown :active="isActive" :duration="400">
        <ul class="header-user-block__list-flex">
            <li v-for="(item, index) in items" :key="index" class="header-user-block__list-dropdown-item">
              <a class="header-user-block__list-dropdown-link" :class="{active: item.code2 === current}" v-if="isLanguage"
                :href="item.url" :data-code="item.code2">
                <img class="flag" :src="`/img/flags/lang-header/${item.code2}.svg?v=3`" :alt="`flag-${item.code2}`">
                <span>
                    {{ item.code2 }}
                </span>
              </a>
              <a class="header-user-block__list-dropdown-link" :class="{active: item.code === code, [`currency-item_${item.code}`]: true}" v-else
                  :href="`?currency_id=${item.id}`">
                  <span class="symbol header-user-block__list-currency-symbol">
                      {{ item.symbol }}
                  </span>
                  <span>
                      {{ item.code }}
                  </span>
              </a>
            </li>
        </ul> 
      </SlideUpDown>
    </div>
  </li>
</template>
  
<script>
import SlideUpDown from 'vue-slide-up-down';

  export default {
    name: "DropdownMenuSidebar",
    components: {
      SlideUpDown
    },
    props: {
      code: {
        type: String,
        required: true,
      },
      current: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      path: {
        type: String,
        required: true,
      },
      isLanguage: {
        type: Boolean,
        required: true,
      },
      isActive: {
        type: Boolean,
        required: true,
      }
    },
    methods: {
      toggleDropdown() {
        this.$emit('toggle');
      },
    },
  };
  </script>